import createRoute     from '@widesk-ui/tools/createRoute';
import ProductSetModel from '@models/shop/ProductSetModel';

export default createRoute.splitView('/entertainments/:entertainmentId/product_sets', 'shop', 'ProductSetSplitView', ProductSetModel.localize('plural'));
